<template>
  <div class="book">
    <div class="coverInfo">
      <img class="coverImage" src="//textcafe.co/books/QF9utu/images/e9781439633878_cover.jpg?1684305911901" alt="This image is the cover for the book Snyder County's Sports Heritage, Images of Sports"/>
    </div>
    <div class="bookInfo">
      <h1 class="bookTitle heading font1">Snyder County's Sports Heritage, Images of Sports
      </h1>
      <p class="bookDescription body article font2">
        <p>If Snyder County sports fans are not the most rabid in the nation, they certainly are among the most rabid. Regardless of the community, regardless of the sport or level at which it is played, Snyder County teams enjoy unconditional support second to none. Through the years, Snyder County has seen more than its share of athletic greatness. Those highly successful athletes, as well as those who played just for the love of the game, are represented in the more than 200 new and different images in this volume.</p>
      </p>
    </div>
    <div class="authorInfo">
      <h2 class="authorName heading font1">
        Jim Campbell
      </h2>
      
      <p class="authorDescription body article">Jim Campbell, a member of the Pro Football Writers of America, and the Snyder County Historical Society collaborated to produce Snyder County�s Sports Heritage, their third Snyder County book. Proceeds from book sales benefi t the Snyder County Historical Society.</p>
      
      
    </div>
    <div class="publisherInfo">
     <h2 class="publisherName heading font1">
      Arcadia Publishing
     </h2>
        
        
     
    </div>
  </div>
</template>

<script>
// import Navigation from '@/components/Navigation'
export default {
  name: 'home',
  data() {
    return {}
  },
  components: {
    // 'navigation': Navigation
  }
}
</script>


// WEBPACK FOOTER //
// home.vue?633de535